import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import {
  SIGNING_PROGRESS_INFORMATION__FETCH_FAILURE,
  SIGNING_PROGRESS_INFORMATION__FETCH_REQUEST,
  SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import Attachment from '@app/store/document/Attachment';
import Document from '@app/store/document/Document';
import { RequesterAttachment } from '@app/store/documentSetup/RequesterAttachment';
import History from '@app/store/signingProgressInformation/History';

export interface ParticipantAuth {
  digitalCertificate: {
    bizNumber: string;
    companyName: string;
  } | null;
  mobile: {
    phoneNumber: string;
    realName: string;
  } | null;
  password: boolean;
  participantId: string;
}

export const fetchSigningProgressInformation = createAction<
  { documentId: string },
  typeof SIGNING_PROGRESS_INFORMATION__FETCH_REQUEST
>(SIGNING_PROGRESS_INFORMATION__FETCH_REQUEST);

export const fetchSigningProgressInformationSuccess = createAction<
  {
    attachments: Attachment[];
    document: Document;
    histories: History[];
    participantAuths: ParticipantAuth[];
    requesterAttachments: RequesterAttachment[];
  },
  typeof SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS
>(SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS);

export function fetchSigningProgressInformationFailure(error: AxiosError) {
  return {
    type: SIGNING_PROGRESS_INFORMATION__FETCH_FAILURE,
    payload: error,
    error: true,
  };
}

export type SigningProgressInformationAction =
  | ReturnType<typeof fetchSigningProgressInformation>
  | ReturnType<typeof fetchSigningProgressInformationSuccess>
  | ReturnType<typeof fetchSigningProgressInformationFailure>;
